import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { KitDetails } from './components/KitDetails';
import { BeforeAfter } from './components/BeforeAfter';
import { BonusSection } from './components/BonusSection';
import { SecretBonuses } from './components/SecretBonuses';
import { SummarySection } from './components/SummarySection';
import { SocialProof } from './components/SocialProof';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code - ID: 2449650828824513
    /* eslint-disable */
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '2449650828824513');
    // @ts-ignore
    fbq('track', 'PageView');
    /* eslint-enable */
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <KitDetails data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <BonusSection data-id="element-9" />
        <SecretBonuses data-id="element-10" />
        <SummarySection data-id="element-11" />
        <SocialProof data-id="element-12" />
        <PricingSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <FooterSection data-id="element-17" />
    </div>;
}